/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SoldInputs */

const en_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sold`)
};

const es_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vendido`)
};

const fr_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vendu`)
};

const de_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verkauft`)
};

const ja_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売却済み`)
};

const zh_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售出`)
};

const ar_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباع`)
};

const id_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terjual`)
};

const it_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`venduto`)
};

const ru_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`продано`)
};

const pt_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vendido`)
};

const ko_sold = /** @type {(inputs: SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 완료`)
};

/**
* | output |
* | --- |
* | "sold" |
*
* @param {SoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sold = /** @type {((inputs?: SoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sold(inputs)
	if (locale === "es") return es_sold(inputs)
	if (locale === "fr") return fr_sold(inputs)
	if (locale === "de") return de_sold(inputs)
	if (locale === "ja") return ja_sold(inputs)
	if (locale === "zh") return zh_sold(inputs)
	if (locale === "ar") return ar_sold(inputs)
	if (locale === "id") return id_sold(inputs)
	if (locale === "it") return it_sold(inputs)
	if (locale === "ru") return ru_sold(inputs)
	if (locale === "pt") return pt_sold(inputs)
	return ko_sold(inputs)
});